import {
  successNotifyService,
  failureNotifyService,
} from "@/services/errors.service.js";
import { isArray } from "core-js/fn/array";
import { isInteger } from "core-js/fn/number";
import { isBoolean } from "lodash";

export function checkInputFieldService(localData, action) {
  let cfObj = {};

  //////////////////////////////////////
  /// Users Collection
  //////////////////////////////////////

  if (action === "saveCompany" && localData.company) {
    cfObj.fieldName = "company";
    cfObj.fieldValueIsNull = false;
    cfObj.collectionName = "careerHistory";
    cfObj.vuexServiceName = "editor";
    return cfObj;
  } else if (action === "saveTitle" && localData.title) {
    cfObj.fieldName = "title";
    cfObj.fieldValueIsNull = false;
    cfObj.collectionName = "careerHistory";
    cfObj.vuexServiceName = "editor";
    return cfObj;
  } else if (action === "saveStartDate" && localData.startDate) {
    cfObj.fieldName = "startDate";
    cfObj.fieldValueIsNull = false;
    cfObj.collectionName = "careerHistory";
    cfObj.vuexServiceName = "editor";
    return cfObj;
  } else if (action === "saveEndDate" && localData.endDate) {
    cfObj.fieldName = "endDate";
    cfObj.fieldValueIsNull = false;
    cfObj.collectionName = "careerHistory";
    cfObj.vuexServiceName = "editor";
    return cfObj;
  } else if (action === "saveCurrentlyActive") {
    cfObj.fieldName = "currentlyActive";
    cfObj.fieldValueIsNull = false; // Can be null (faked)
    cfObj.collectionName = "careerHistory";
    cfObj.vuexServiceName = "editor";
    return cfObj;
  } else if (action === "saveCountry" && localData.country) {
    cfObj.fieldName = "country";
    cfObj.fieldValueIsNull = false;
    cfObj.collectionName = "careerHistory";
    cfObj.vuexServiceName = "editor";
    return cfObj;
  } else if (action === "saveCity" && localData.city) {
    cfObj.fieldName = "city";
    cfObj.fieldValueIsNull = false;
    cfObj.collectionName = "careerHistory";
    cfObj.vuexServiceName = "editor";
    return cfObj;
  } else if (action === "saveDescription") {
    cfObj.fieldName = "description";
    cfObj.fieldValueIsNull = false; // this field can be null
    cfObj.collectionName = "careerHistory";
    cfObj.vuexServiceName = "editor";
    return cfObj;
  } else if (action === "saveShowExperienceOnMap") {
    cfObj.fieldName = "showExperienceOnMap";
    cfObj.fieldValueIsNull = false; // this field can be null
    cfObj.collectionName = "careerHistory";
    cfObj.vuexServiceName = "editor";
    return cfObj;
  } else if (action === "savePromotion") {
    cfObj.fieldName = "promotions";
    cfObj.fieldValueIsNull = false; // this field can be null
    cfObj.collectionName = "careerHistory";
    cfObj.vuexServiceName = "editor";
    return cfObj;
  } else {
    cfObj.fieldName = null;
    cfObj.fieldValueIsNull = true;
    cfObj.collectionName = null;
    cfObj.vuexServiceName = null;
    return cfObj;
  }
}

export function saveInputFieldService(payload) {
  const isUserLoggedIn = payload.isUserLoggedIn;
  const action = payload.action;
  const currentThis = payload.currentThis;
  const localData = payload.localData;
  const careerHistoryId = payload.careerHistoryId;

  const cfObj = checkInputFieldService(localData, action);

  // // console.log(cfObj, payload);

  if (!isUserLoggedIn || cfObj.fieldValueIsNull) {
    return;
  }

  currentThis.$store.commit("editor/TOGGLE_SAVE_IN_PROGRESS", true);
  // // console.log("executing...", localData);

  const fieldName = cfObj.fieldName;
  const vuexServiceName = cfObj.vuexServiceName;

  const dataObj = {};
  dataObj["_id"] = careerHistoryId;
  dataObj["collectionName"] = cfObj.collectionName;

  if (localData[`${fieldName}`]) {
    // If field value is not null

    if (isInteger(localData[`${fieldName}`])) {
      dataObj[`${fieldName}`] = Number(
        localData[`${fieldName}`].toString().trim()
      );
    } else if (isBoolean(localData[`${fieldName}`])) {
      dataObj[`${fieldName}`] = Boolean(
        localData[`${fieldName}`].toString().trim()
      );
    } else if (isArray(localData[`${fieldName}`])) {
      dataObj[`${fieldName}`] = localData[`${fieldName}`];
    } else if (typeof localData[`${fieldName}`] === "object") {
      dataObj[`${fieldName}`] = localData[`${fieldName}`];
    } else {
      dataObj[`${fieldName}`] = localData[`${fieldName}`].trim();
    }
  } else dataObj[`${fieldName}`] = null; // If field value is null


  currentThis.$store
    .dispatch(`${vuexServiceName}/${action}`, dataObj)
    .then((res) => {
      currentThis.$store.commit("editor/TOGGLE_SAVE_IN_PROGRESS", false);
      //// console.log(res);
    })
    .catch((err) => {
      throw err;
    });
}

export function deleteDocumentService(payload) {
  const currentThis = payload.currentThis;
  const careerHistoryId = payload.careerHistoryId;

  currentThis.$store
    .dispatch("editor/deleteCareerHistory", careerHistoryId)
    .then((res) => {
      successNotifyService({
        currentThis,
        title: "Career History Deleted",
        text: "This career history has been successfully deleted.",
      });
    })
    .catch((err) => {
      throw err;
    });
}
